// When hosted on the server, content such as images could be served through the
// a modified directory path different to that of a local running instance
// * the prefix will allow easy adaptation to such modifications right in env constants
const IMG_PATH_PREFIX = process.env.STATIC_RESOURCE_PATH;

export const AUTH_CONNECTED_SRC = `${IMG_PATH_PREFIX}loginlogo.png`;
export const AUTH_DISCONNECTED_SRC = `${IMG_PATH_PREFIX}loginlogogrey.png`;

export const MAGNET_LOGO_SRC = `${IMG_PATH_PREFIX}logo.png`;

export const TOASTS_AVAILABLE_SRC = `${IMG_PATH_PREFIX}toastsAvailable.png`;
export const TOASTS_UNAVAILABLE_SRC = `${IMG_PATH_PREFIX}toastsUnavailable.png`;

export const SERVER_CONNECTED_SRC = `${IMG_PATH_PREFIX}connected.png`;
export const SERVER_DISCONNECTED_SRC = `${IMG_PATH_PREFIX}disconnected.png`;

export const SETTINGS_AVAILABLE_SRC = `${IMG_PATH_PREFIX}settingsAvailable.png`;
export const SETTINGS_UNAVAILABLE_SRC = `${IMG_PATH_PREFIX}settingsUnavailable.png`;

export const JIRA_BASE_URL = 'https://magnet-forensics.atlassian.net';


// WEBPACK FOOTER //
// src/helpers/urls.js